import { render, staticRenderFns } from "./member-welfare.vue?vue&type=template&id=a76ab61a&scoped=true"
import script from "./member-welfare.vue?vue&type=script&lang=js"
export * from "./member-welfare.vue?vue&type=script&lang=js"
import style0 from "./member-welfare.vue?vue&type=style&index=0&id=a76ab61a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76ab61a",
  null
  
)

export default component.exports